import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "18",
  fill: "none",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.44 18H0L5.287 3.95 6.833 0h20.382z",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m18.309 9.13-3.395 3.395a.185.185 0 1 1-.261-.26l3.08-3.08H9.821a.185.185 0 1 1 0-.37h7.91l-3.08-3.08a.185.185 0 0 1 .262-.26l3.395 3.394a.184.184 0 0 1 0 .262"
    }, null, -1)
  ]))]))
}
export default { render: render }